import { Component, Input, QueryList, ContentChildren } from '@angular/core';
import { PageInfo } from '../../interfaces/pageInfo';
import { TextButtonComponent } from '../text-button/text-button.component';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';

// Component for displaying the page header. Accepts a PageInfo input, which is
// created by he PageInfoService.
@Component({
    selector: 'gbc-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
    imports: [
    BreadcrumbComponent,
    RouterLink,
    NgClass,
    TextButtonComponent,
    AsyncPipe
],
})
export class PageHeaderComponent {
  @Input()
  public pageInfo: PageInfo;

  public menuOpen = false;

  @ContentChildren(TextButtonComponent)
  public buttons: QueryList<TextButtonComponent>;

  constructor() {}
}
